export const environment = {
  production: false,
    api: 'https://develop-api.lideresapla.com/api/',
    evidencePath: 'https://develop-api.lideresapla.com/api/storage'
};
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

